import React from 'react';
import { GiaiQuyetDonThu } from 'api';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { DropDown, TextArea} from 'components/tt-forms/common';
import { DropDownChonStateXuLyDon } from 'components/tt-forms';
import { msg } from "constants/message";
import { processType } from 'constants/process-type';

const process = [processType.xuLyDon.processing.trinhLanhDao];

class TrinhLanhDaoKTDX extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_TrinhLanhDaoKTDX: false,

      donId: this.props.donId,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      lanhDaoChiDinh: '',
      noiDung: ''
    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {

      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {

          case 'TRINH_LANH_DAO':
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_TrinhLanhDaoKTDX: true
            });
            break;
        }
      }
    });
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {

    GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(res => {
      if (res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            lanhDaoChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            noiDung: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
          });
      }
    }).then(() => {
      this.onlyOneState()
    });
  }

  onlyOneState() {

    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState));
    }
  }

  handleChange(name, e) {
    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    if (name == 'nextState') {


      if (this.state.donId == 0) {
        newState = {
          ...newState
        }
      }
    }

    this.setState({
      ...newState
    }, this.trigger(newState));
  }

  trigger(newState) {

    if (newState.nextState) {
      let stateId = this.props.getState(this.props.listNextStates, newState.nextState);

      let paramsPatch = this.state.dataGiaiQuyetDon;
      let paramsPost = {};

      paramsPatch.nextState = {
        id: Number(stateId),
        type: this.state.onlyState
      }

      paramsPost.nextState = {
        id: Number(stateId),
        type: this.state.onlyState
      }

      if (newState.form_TrinhLanhDaoKTDX && newState.nextState == 'TRINH_LANH_DAO') {

        if (newState.lanhDaoChiDinh){
          paramsPatch.canBoXuLyChiDinh = {id: Number(newState.lanhDaoChiDinh)};
          paramsPost.canBoXuLyChiDinh = {id: Number(newState.lanhDaoChiDinh)};
        }


        paramsPatch.yKienGiaiQuyet = newState.noiDung;
        paramsPost.yKienGiaiQuyet = newState.noiDung;
      }

      paramsPost.thongTinGiaiQuyetDon = {
        id: this.props.thongTinGiaiQuyetDonId
      }

      let params = {
        paramsPatch: paramsPatch,
        paramsPost: paramsPost,
        notice: msg.ktdxTrinhLanhDao
      }

      this.props.onChange(params);
    }
  }

  render() {
    return (
      <div className="items-form">
        <ShowIf condition={!this.state.hideDropdown}>
          <div className="row pl10 pr10">
            <DropDownChonStateXuLyDon require
              value={this.state.nextState}
              label="Hướng xử lý"
              onChange={this.handleChange.bind(this, 'nextState')}
              data={this.props.listNextStates}
              bindValidator={this}
              name="dropdownChonXuLy" />
          </div>
        </ShowIf>
        <ShowIf condition={this.state.form_TrinhLanhDaoKTDX}>
          <div className="row pl10 pr10">
            <DropDown
              label="Ban lãnh đạo"
              options={this.props.lanhDaoList}
              keyName="congChucId"
              valueName="hoVaTen"
              selectedValue={this.state.lanhDaoChiDinh}
              onChange={this.handleChange.bind(this, 'lanhDaoChiDinh')}
              placeholder={this.props.placeholder}
              name="chonBanlanhDaoTTXM" />
          </div>
          <div className="row pl10 pr10">
            <TextArea
              label="Ý kiến xử lý"
              value={this.state.noiDung}
              onChange={this.handleChange.bind(this, 'noiDung')}
              name="textareaYKien" />
          </div>
        </ShowIf>
      </div>
    );
  }
}

TrinhLanhDaoKTDX.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  }
}

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList
  }
}

export default connect(bindStateToProps)(TrinhLanhDaoKTDX);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat/chuyen-vien-nhap-lieu/TrinhLanhDaoKTDX.jsx